// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
    color: black;
}
.info-soc-cli
{
    border-left: 1px dotted rgba(0, 0, 0, 0.425);
}
b {
    font-weight: 500;
}
.btn-custom {

    background-color: #822FA7;
    color: #f0f0f0;
    /* font-size: 1rem; */
}
.btn-exportcsv {

    background-color: #1f7246;
    color: #f0f0f0;
    /* font-size: 1rem; */
}
.btn-secondary-2 {
    background-color: #50575d;
    color: #f0f0f0;
}
.btn-secondary-2:hover {
    background-color: #464c51;
    color: #f0f0f0;
}
.btn-custom:hover{
    color: white;
    background-color: #692686;
}
@media screen and (max-width: 767px) {
    .h5-res {
        margin-top: 20px;
    }
}

/* Estilos para iconos de exito o tacha en Status */
.fa-check-circle {
    color: green;
}
.fa-times-circle, .fa-ban {
    color: rgb(219, 0, 0);
}

/* Estilo para el checkbox */
.form-check-input[type="checkbox"] {
    transform: scale(1.5);
    /* margin-right: 10px;  */
}
.bg-purple {
    background-color: #822FA7;
}
.radioBtn {
    margin-left: -.3rem;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}
  `, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/entrenadores/entrenadores.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;;IAEI,4CAA4C;AAChD;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;AACA;;IAEI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA,mDAAmD;AACnD;IACI,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;;AAEA,4BAA4B;AAC5B;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,wBAAwB;AAC5B","sourcesContent":["h2 {\n    color: black;\n}\n.info-soc-cli\n{\n    border-left: 1px dotted rgba(0, 0, 0, 0.425);\n}\nb {\n    font-weight: 500;\n}\n.btn-custom {\n\n    background-color: #822FA7;\n    color: #f0f0f0;\n    /* font-size: 1rem; */\n}\n.btn-exportcsv {\n\n    background-color: #1f7246;\n    color: #f0f0f0;\n    /* font-size: 1rem; */\n}\n.btn-secondary-2 {\n    background-color: #50575d;\n    color: #f0f0f0;\n}\n.btn-secondary-2:hover {\n    background-color: #464c51;\n    color: #f0f0f0;\n}\n.btn-custom:hover{\n    color: white;\n    background-color: #692686;\n}\n@media screen and (max-width: 767px) {\n    .h5-res {\n        margin-top: 20px;\n    }\n}\n\n/* Estilos para iconos de exito o tacha en Status */\n.fa-check-circle {\n    color: green;\n}\n.fa-times-circle, .fa-ban {\n    color: rgb(219, 0, 0);\n}\n\n/* Estilo para el checkbox */\n.form-check-input[type=\"checkbox\"] {\n    transform: scale(1.5);\n    /* margin-right: 10px;  */\n}\n.bg-purple {\n    background-color: #822FA7;\n}\n.radioBtn {\n    margin-left: -.3rem;\n}\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
